const NaviTypeTab = ({
  naviSearch,
  setNaviSearch,
  setResultError
}) => {
  const selectType = (type) => {
    if (setNaviSearch) {
      setNaviSearch({ ...naviSearch, type });
      setResultError("");
    }
  };

  const activeClass = (type) => (naviSearch.type === type ? 'active' : '');

  return (
    <div className="route-options">
      {/* 交通手段選択 */}
      <div className="transport-mode">
          <button className={`transport-btn ${activeClass('drive')}`} title="車" onClick={() => selectType('drive')}>
              <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/directions_cars_24.svg')` }}></i>
              <span>車</span>
          </button>
          <button className={`transport-btn ${activeClass('walk')}`} title="徒歩" onClick={() => selectType('walk')}>
              <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/directions_walk.svg')` }}></i>
              <span>徒歩</span>
          </button>
          <button className={`transport-btn ${activeClass('transit')}`} title="電車" onClick={() => selectType('transit')}>
              <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/directions_train_24.svg')` }}></i>
              <span>電車</span>
          </button>
      </div>
    </div>
  );
};

export default NaviTypeTab;